import React from "react";

const OurVisionSection = () => {
  return (
    <section className="w-full bg-[#163f5f]">
      <div
        className="
          mx-auto max-w-7xl
          px-4 sm:px-6 lg:px-8
          py-12 sm:py-16 lg:py-20
        "
      >
        <div
          className="
            grid grid-cols-1
            lg:grid-cols-2
            gap-10 lg:gap-16
            items-center
          "
        >
          {/* Left Content */}
          <div>
            <h2
              className="
                text-white
                font-semibold
                text-2xl sm:text-3xl lg:text-4xl
              "
            >
              Our Vision
            </h2>

            <p
              className="
                mt-4
                max-w-xl
                text-white/85
                text-sm sm:text-base
                leading-7 sm:leading-8
              "
            >
              Our vision is to empower organizations worldwide by delivering
              high-quality services that create real, lasting value. We begin by
              understanding each client’s business and goals, then help turn
              their vision into reality through the right combination of
              consulting expertise, strategic thinking, and technology. As we
              continue to grow, we remain guided by the values that have shaped
              our success. These principles enable us to build a balanced,
              inclusive, and respectful environment for our people and our
              clients alike.
            </p>
          </div>

          {/* Right Image */}
          <div className="flex justify-center lg:justify-end">
            <div className="w-full max-w-sm sm:max-w-md lg:max-w-lg">
              <img
                src="/assets/our-vision.webp"
                alt="Business vision and strategy"
                className="
                  w-full
                  object-cover
                  rounded-2xl
                  aspect-[4/3]
                "
                loading="lazy"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default OurVisionSection;
